module.exports = __webpack_public_path__ + "fonts/Manrope-500-cyrillic8.765433f.woff2";